const methods = {
  subsetObjectByKeys: <T extends {}, K extends keyof T>(obj: T, keys: K[]) => (
    Object.fromEntries(
      Object.keys(obj)
        .filter(key => keys.includes(key as K))
        .map(key => {
          return [key, obj[key]];
        })
    ) as Pick<T, K>
  ),
}

export function useObjectSubset(
  method: keyof typeof methods,
  data: any[] | { [key: string]: any },
  array: any[],
) {
  const parsingMethod = methods[method];
  return parsingMethod(data, array);
};
